import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { HiBars2 } from 'react-icons/hi2';
import { Dots } from '../SvgIcon';
import ServiceItem from './ServiceItem';

function CategoryItem({
  category,
  isCollapsed,
  onToggleAll,
  isDragging,
  mouseDownPosition,
  setMouseDownPosition,
  dragThreshold,
  onOpenCategoryDetail,
  mobileDotServicePopup,
  deleteService,
  onOpenServiceDetail,
  isSalonOwner,
  isSelfEmployed,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id: category.id, disabled: !!category.isFeaturedCategory });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  // console.log("widthserviceitem-category",width)
  const handleMouseDown = (e) => {
    console.log('Mouse Down:', e.clientY);
    setMouseDownPosition(e.clientY);
    handleScroll()
  };

  const handleMouseUp = (e) => {
    console.log('Mouse Up:', e.clientY);
    if (mouseDownPosition) {
      const distance = Math.abs(e.clientY - mouseDownPosition);
      console.log('Movement distance:', distance);
      
      if (distance <= dragThreshold) {
        console.log('Treating as click - toggling categories');
        onToggleAll();
      }
    }
    setMouseDownPosition(null);
  };

  const handleMouseMove = (e) => {
    if (mouseDownPosition) {
      const distance = Math.abs(e.clientY - mouseDownPosition);
      if (distance > dragThreshold) {
        console.log('Drag threshold exceeded:', distance);
      }
    }
  };

 const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerHeight = 80; 
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  
  return (
    <div 
      ref={setNodeRef} 
      style={style}  
      className={`service-category category ${category?.id}`} 
      data-dragging={isDragging}
      data-collapsed={isCollapsed}
      id={category?.id}
    >
      <div 
      // className="category-header"
      className="category-header"
      >
         <div
           className={`_first ${category?.id}`}
           {...(category.isFeaturedCategory ? {} : attributes)}
           {...(category.isFeaturedCategory ? {} : listeners)}
           onMouseDown={handleMouseDown}
           onMouseUp={handleMouseUp}
           onMouseMove={handleMouseMove}
           onClick={()=>handleScroll(category?.id)}
           title={category.isFeaturedCategory ? 'Click to toggle' : 'Click to toggle / Drag to reorder'}
           style={{ cursor: category.isFeaturedCategory ? 'pointer' : 'grab' }}
         >
               {!category.isFeaturedCategory && (
                 <HiBars2 className="menu-icon category-menu-icon drag-handle" />
               )}
                <svg className={`cat-chevron ${isCollapsed ? '' : 'cat-chevron--open'}`} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
                <h2>{category.category}</h2>
                {isCollapsed && category.items?.length > 0 && (
                  <span className="cat-count">{category.items.length} {category.items.length === 1 ? 'service' : 'services'}</span>
                )}
         </div>
         {!category.isFeaturedCategory && (
           <div
             className="transaction_Dropdown __service_dropdown"
             onClick={(e) => {
               e.stopPropagation();
               if (onOpenCategoryDetail) {
                 onOpenCategoryDetail({ id: category.id, name: category.category, itemCount: category.items?.length || 0 });
               }
             }}
           >
             <span><Dots /></span>
           </div>
         )}
      </div>

      

      {/* <div className={`items ${isCollapsed ? 'collapsed' : ''}`}> */}
      <div className={`service-items ${isCollapsed ? 'collapsed' : ''}`} >
        {!isCollapsed && (
          <SortableContext 
            items={category.items.map(item => item.id)}
            strategy={verticalListSortingStrategy}
          >
            {category.items.map((item) => (
              <ServiceItem
                key={item.id}
                item={item}
                category={category.id}
                mobileDotServicePopup={mobileDotServicePopup}
                deleteService={deleteService}
                onOpenDetail={onOpenServiceDetail}
                isSalonOwner={isSalonOwner}
                isSelfEmployed={isSelfEmployed}
              />
            ))}
          </SortableContext>
        )}
      </div>
    </div>
  );
}

export default CategoryItem;
